import apiClient from './apiClient';
import { getIdNameIfAdmin } from '../utils/commonutils';

const Url = `/task`;

export const getTasks = async (props) => {
    try{
        let response = await apiClient.get(`${Url}/list-kanban`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const addTask = async (props, thisEvt) => {
    try{
        const taskType = thisEvt.state?.addTaskType?.value || 'Other';
        const requiredDocumentTypes = Array.isArray(thisEvt.state?.addRequiredDocumentTypes)
            ? thisEvt.state.addRequiredDocumentTypes
            : [];
        let body = {
            "name" : thisEvt.state?.addName,
            "description" : thisEvt.state?.addDescription,
            "priority" : thisEvt.state?.addPriority?.value,
            "status" : thisEvt.state?.addStatus?.value,
            "employeeId" : thisEvt.state?.addEmployeeId?._id,
            "customerId" : thisEvt.state?.addCustomerId?._id,
            "deadline" : thisEvt.state?.addDeadline,
            "files" : Array.isArray(thisEvt.state?.addFiles) ? thisEvt.state.addFiles : [],
            "taskType" : taskType,
            "requiredDocumentTypes" : requiredDocumentTypes,
        }
        console.log("Add Task Body : ", body);
        let response = await apiClient.post(`${Url}/`, body);
        console.log('Add Task : ',response);
        if(response && response.status === 200) return response.data;
        return response;
    } catch(error) {
        console.log('error', error, error.response);
        return error;
    }
}

export const editTask = async (props, thisEvt) => {

    try{
        const taskType = thisEvt.state?.editTaskType?.value || 'Other';
        const requiredDocumentTypes = Array.isArray(thisEvt.state?.editRequiredDocumentTypes)
            ? thisEvt.state.editRequiredDocumentTypes
            : [];
        let body = {
            "name" : thisEvt.state?.editName,
            "description" : thisEvt.state?.editDescription,
            "priority" : thisEvt.state?.editPriority?.value,
            "status" : thisEvt.state?.editStatus?.value,
            "employeeId" : thisEvt.state?.editEmployeeId?._id,
            "customerId" : thisEvt.state?.editCustomerId?._id,
            "deadline" : thisEvt.state?.editDeadline,
            "files" : Array.isArray(thisEvt.state?.editFiles) ? thisEvt.state.editFiles : [],
            "taskType" : taskType,
            "requiredDocumentTypes" : requiredDocumentTypes,
        }
        console.log("Edit Task Body : ", body);
        let response = await apiClient.put(`${Url}/?taskId=${thisEvt.state?.editId}`, body);
        console.log('Add Task : ',response);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const getTaskDetail = async (payload, props) => {
    try{
        if(!payload && payload.taskId) return false;
        let response = await apiClient.get(`${Url}/${payload.taskId}`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const deleteTask = async (payload, props) => {
    console.log('Delete Task - ', props, payload);
    try{
        if(!payload && payload.taskId) return false;
        let response = await apiClient.delete(`${Url}/?taskId=${payload.taskId}`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const toggleModal = (thisEvt) => {
    const employeeObj = getIdNameIfAdmin(thisEvt?.props?.authData);
    thisEvt.setState({
        addModel: !thisEvt.state.addModel,
        addError: [],
        addName: "",
        addDescription: "",
        addPriority: null,
        addStatus: null,
        addDeadline: "",
        addCustomerId: null,
        addEmployeeId: employeeObj || null,
        addFiles: [],
    })
}

export const toggleCusModal = (thisEvt) => {
    thisEvt.setState({
        addCustomerModel: !thisEvt.state.addCustomerModel,
        addCusError: [],
        addCusName: "",
        addEmail: "",
        addMobile: "",
        addGST: "",
        addCompanyName: "",
        addOfficeAddr: "",
    })
}

export const toggleEditModal = async(thisEvt, task = null , props) => {
    const res = await getTaskDetail({taskId :  task?._id} , thisEvt.props)
    const Data = res?.data || {}
    console.log('Toggle Edit Model : ', thisEvt,task);
    const taskTypeValue = Data?.taskType || task?.taskType || 'Other';
    const requiredDocs = Array.isArray(Data?.requiredDocumentTypes)
        ? Data.requiredDocumentTypes
        : (Array.isArray(task?.requiredDocumentTypes) ? task.requiredDocumentTypes : []);
    thisEvt.setState({
        editModel: !thisEvt.state.editModel,
        editError: [],
        editId: task?._id ?? "",
        editName: task?.name ?? "",
        editDescription: task?.description ?? "",
        editPriority: { name: task?.priority ?? "", value: task?.priority ?? "" },
        editStatus: { name: task?.status ?? "", value: task?.status ?? "" },
        editDeadline: task?.deadline ?? "",
        editCustomerId: Data?.customerId || task?.customerId || null,
        editEmployeeId: Data?.employeeId || task?.employeeId || null,
        editFiles: task?.files ?? [],
        editTaskType: { name: taskTypeValue, value: taskTypeValue },
        editRequiredDocumentTypes: requiredDocs,
    });
}

export const handleChange = (e,thisEvt) => {
    thisEvt.setState({
        [e.target.name]: e.target.value
    })
}
export const addTaskThread = async (props, data) => {
    try{
        let body = {
            "taskId" : data?.taskId,
            "text" : data?.text,
            "createdBy" : data?.createdBy,
            "files" : data?.files,
        }
        console.log("Add Task Thread Body : ", body);
        let response = await apiClient.post(`${Url}/${data?.taskId}/thread/`, body);
        console.log('Add Task : ',response);
        if(response && response.status === 200) return response.data;
        return response;
    } catch(error) {
        console.log('error', error, error.response);
        return error;
    }
}

export const getTaskThread = async (props, data) => {
    console.log("gettaskthread",props,data)
    try{
        console.log("Get Task Thread  : ", data);
        let response = await apiClient.get(`${Url}/${props?.taskId}/thread/${props?.taskId}`);
        console.log('Get Tasks : ',response);
        if(response && response.status === 200) return response.data;
        return response;
}catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

// getTaskStatusHistory
export const getTaskStatusHistory = async (props, data) => {
    try{
        console.log("Get Task Status Hisotry  : ", data);
        let response = await apiClient.get(`${Url}/get-history/${data?.taskId}`);
        console.log('Get Tasks Status History: ',response);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}
